import moment from 'moment';

const config = {
  // Table Columns
  columns: [
    {
      title: 'Action ID',
      dataIndex: 'action__id',
      sorter: true,
      defaultSortOrder: 'descend',
      width: '100px',
      render: (text, record) => (record.action ? record.action.id : '')
    },
    {
      title: 'Message',
      dataIndex: 'message',
      width: '100px',
      render: (text, record) => record.message
    },
    {
      title: 'Action Type',
      dataIndex: 'action_type__name',
      key: 'action_type__name',
      sorter: true,
      width: '180px',
      render: (text, record) => (record.action ? record.action.action_type : 'NA')
    },
    {
      title: 'Follow Up Date',
      dataIndex: 'follow_up_date',
      sorter: true,
      width: '120px',
      render: (text, record) => (record.action && record.action.follow_up_date ? moment(record.action.follow_up_date)
        .format('DD-MM-YYYY HH:mm') : 'NA')
    },
    {
      title: 'Requestor',
      dataIndex: 'requestor__last_name',
      sorter: true,
      width: '180px',
      render: (text, record) => (record.action ? `${record.action.requestor.last_name}, ${record.action.requestor.first_name}` : 'NA')
    }
  ],
  sorter: {
    field: 'action__id',
    order: 'descend'
  },
  filters: {},
  customFilters: {
    action_type__name: {
      filterDropdownVisible: false,
      filtered: false,
      contains: true,
      searchFields: ['action_type__name'],
      searchValue: ''
    },
    requestor__last_name: {
      filterDropdownVisible: false,
      filtered: false,
      contains: true,
      searchFields: ['requestor__last_name'],
      searchValue: ''
    }
  },
  commands: {
    showAdd: false,
    showDelete: false,
    showRefresh: false
  }
};

export default config;
